var _path, _path2, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCard3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 320,
    height: 180,
    viewBox: "0 0 320 180",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 50C0 22.3858 22.3858 0 50 0H270C297.614 0 320 22.3858 320 50V180H0V50Z",
    fill: "#D0CBFD"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_147_4",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 320,
    height: 180
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 50C0 22.3858 22.3858 0 50 0H270C297.614 0 320 22.3858 320 50V180H0V50Z",
    fill: "#D0CBFD"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_147_4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M269.982 167.689C265.018 172.913 260.322 176.284 256.615 178.946C212.999 210.241 161.389 201.119 150.419 198.89C134.215 195.602 102.91 189.239 80.2747 162.623C46.0292 122.351 51.3611 58.9028 77.9246 17.0203C82.7836 9.35864 108.45 -33.1619 160.613 -39.9808C192.183 -44.1082 228.984 -35.7846 255.634 -13.457C311.577 33.4106 307.595 128.091 269.982 167.689Z",
    fill: "#D0CBFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.2784 153.639L79.387 163.787C80.3853 165.447 81.8769 166.753 83.6535 167.525C85.43 168.296 87.4031 168.493 89.2972 168.089L98.4962 166.131C99.7215 165.875 100.991 165.919 102.195 166.258C103.4 166.598 104.505 167.223 105.417 168.081C110.051 172.401 115.164 176.175 120.656 179.331C121.746 179.951 122.67 180.824 123.35 181.877C124.03 182.93 124.445 184.132 124.561 185.38L125.393 194.757C125.564 196.686 126.332 198.513 127.59 199.984C128.849 201.455 130.535 202.497 132.414 202.964L143.91 205.822C145.789 206.288 147.766 206.158 149.567 205.447C151.368 204.737 152.902 203.483 153.956 201.859L159.08 193.962C159.767 192.913 160.697 192.045 161.791 191.433C162.885 190.821 164.11 190.482 165.363 190.445C171.694 190.227 177.979 189.286 184.096 187.639C185.303 187.307 186.573 187.272 187.796 187.536C189.02 187.8 190.162 188.356 191.125 189.156L198.336 195.193C199.821 196.435 201.656 197.184 203.586 197.334C205.516 197.484 207.444 197.028 209.103 196.03L219.251 189.921C220.91 188.923 222.216 187.432 222.987 185.656C223.758 183.881 223.956 181.909 223.552 180.015L221.594 170.817C221.338 169.592 221.382 168.323 221.722 167.118C222.061 165.913 222.686 164.807 223.545 163.896C227.864 159.262 231.638 154.149 234.794 148.657C235.413 147.567 236.287 146.643 237.34 145.963C238.393 145.283 239.595 144.867 240.843 144.751L250.22 143.92C252.149 143.75 253.976 142.982 255.447 141.723C256.919 140.464 257.96 138.778 258.427 136.899L261.285 125.403C261.752 123.524 261.621 121.547 260.911 119.746C260.201 117.946 258.946 116.411 257.322 115.358L249.425 110.232C248.376 109.546 247.509 108.616 246.897 107.522C246.284 106.428 245.946 105.202 245.909 103.949C245.69 97.6182 244.749 91.3333 243.102 85.2165C242.771 84.0095 242.735 82.7402 242.999 81.5166C243.264 80.293 243.819 79.1513 244.619 78.1885L250.656 70.9768C251.898 69.4924 252.647 67.6574 252.797 65.7275C252.947 63.7977 252.491 61.8691 251.493 60.2106L245.383 50.0621C244.385 48.4037 242.895 47.0982 241.119 46.3273C239.344 45.5564 237.372 45.3587 235.479 45.7617L226.28 47.7199C225.055 47.9759 223.786 47.9322 222.581 47.5926C221.376 47.2531 220.27 46.6277 219.359 45.7697C214.725 41.4507 209.612 37.6762 204.12 34.5198C203.03 33.9006 202.106 33.0273 201.426 31.9743C200.746 30.9212 200.33 29.7195 200.214 28.4713L199.383 19.0941C199.213 17.1654 198.445 15.338 197.186 13.8668C195.928 12.3956 194.241 11.3539 192.362 10.887L180.866 8.02952C178.987 7.56258 177.01 7.69345 175.209 8.40388C173.409 9.11431 171.874 10.3689 170.821 11.9927L165.688 19.8909C165.002 20.9397 164.072 21.8071 162.978 22.4194C161.884 23.0317 160.659 23.3707 159.406 23.4076C153.075 23.6255 146.79 24.5671 140.673 26.2139C139.466 26.5455 138.197 26.5808 136.973 26.3167C135.749 26.0525 134.607 25.4969 133.645 24.6969L126.433 18.6555C124.949 17.4129 123.114 16.6645 121.184 16.5146C119.254 16.3646 117.325 16.8206 115.667 17.8189L105.518 23.9274C103.859 24.9255 102.553 26.4164 101.782 28.1923C101.01 29.9682 100.813 31.9405 101.216 33.8341L103.174 43.0331C103.431 44.2585 103.387 45.5278 103.047 46.7328C102.708 47.9378 102.082 49.043 101.224 49.9544C96.9055 54.5886 93.1311 59.7014 89.9741 65.1931C89.355 66.2831 88.4818 67.2075 87.4287 67.8875C86.3756 68.5675 85.1738 68.9831 83.9256 69.0989L74.5483 69.9276C72.6197 70.098 70.7924 70.8661 69.3212 72.1247C67.85 73.3833 66.8083 75.0696 66.3413 76.9486L63.4838 88.4455C63.017 90.3239 63.1478 92.3011 63.8581 94.1016C64.5683 95.9021 65.8226 97.4361 67.4461 98.4899L75.3435 103.615C76.3924 104.302 77.2599 105.232 77.8722 106.326C78.4845 107.42 78.8234 108.645 78.8601 109.899C79.0781 116.229 80.0197 122.514 81.6664 128.63C81.9979 129.837 82.0332 131.107 81.7693 132.33C81.5053 133.554 80.9499 134.696 80.1503 135.659L74.1186 142.873C72.8756 144.357 72.1267 146.191 71.9761 148.121C71.8255 150.051 72.2808 151.98 73.2784 153.639ZM100.036 136.342C83.7914 101.91 98.5359 60.8265 132.967 44.581C167.398 28.3354 208.482 43.0807 224.728 77.5116C240.974 111.942 226.228 153.027 191.797 169.273C157.366 185.518 116.282 170.771 100.036 136.339V136.342Z",
    fill: "#3D367D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.314 88.8552C193.964 87.2755 168.894 82.6416 142.644 86.4001C133.852 87.6594 126.069 92.7672 121.324 100.274C112.771 113.802 100.681 137.917 103.24 163.067L116.654 166.383C116.654 166.383 125.928 136.543 136.365 124.398C136.365 124.398 148.726 152.575 148.102 168.047C148.085 168.484 148.055 168.911 148.014 169.328C146.596 184.466 207.352 172.152 207.352 172.152L203.567 91.5194C203.538 90.8891 203.301 90.2861 202.893 89.8042C202.486 89.3224 201.931 88.9888 201.314 88.8552V88.8552Z",
    fill: "#FAA701"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.411 60.5389L182.176 81.4872C182.34 83.4358 181.335 85.259 179.661 86.0391C175.806 87.8367 168.402 90.4153 160.485 88.5224C159.036 88.1764 158.092 86.663 158.331 85.1178L163.465 51.9136L180.411 60.5389Z",
    fill: "#E8A988"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.836 35.1499C156.836 35.1499 152.848 50.6286 153.638 58.2921C154.428 65.9555 153.58 71.1463 162.607 71.2725C171.634 71.3987 178.334 65.8417 181.133 57.6346C181.133 57.6346 185.551 44.9728 183.379 40.4262C181.208 35.8797 156.836 35.1499 156.836 35.1499Z",
    fill: "#E8A988"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.263 52.6742L176.153 52.8507C176.153 52.8507 179.228 42.7357 174.945 41.7314C170.663 40.7272 154.22 40.0221 149.883 34.9205C145.701 30.0033 147.53 22.496 151.635 19.8212C151.763 19.7431 151.915 19.7159 152.062 19.745C152.209 19.7741 152.34 19.8574 152.429 19.9783L152.905 20.6128C152.978 20.7091 153.077 20.7816 153.191 20.8209C153.305 20.8602 153.428 20.8646 153.544 20.8335C153.66 20.8024 153.765 20.7372 153.844 20.6463C153.923 20.5553 153.973 20.4429 153.987 20.3233C154.051 19.8124 154.693 19.6006 155.03 19.9898C156.354 21.5112 159.639 23.803 167.502 23.9927C178.658 24.2574 186.523 27.5032 187.896 34.9637C187.915 35.0701 187.962 35.1694 188.032 35.2514C188.102 35.3334 188.194 35.3951 188.296 35.4299C188.398 35.4648 188.508 35.4716 188.614 35.4497C188.719 35.4277 188.817 35.3779 188.897 35.3052C189.619 34.6875 190.863 34.2568 192.804 35.4226C196.18 37.4523 195.999 44.1335 190.333 50.513C190.269 50.5817 190.221 50.6647 190.195 50.7552C190.168 50.8456 190.163 50.941 190.18 51.0337C190.198 51.1264 190.236 51.2138 190.294 51.2887C190.351 51.3637 190.425 51.4241 190.51 51.4652C191.815 52.0459 193.87 53.5964 189.692 56.7671C185.419 60.012 182.611 60.1814 181.524 60.0808C181.383 60.0689 181.251 60.0079 181.15 59.9084C181.05 59.8089 180.987 59.6772 180.974 59.5363L180.323 52.8295C180.315 52.7474 180.291 52.6678 180.251 52.5956C180.211 52.5234 180.157 52.4601 180.091 52.4097C180.026 52.3592 179.951 52.3227 179.871 52.3023C179.792 52.2819 179.708 52.2782 179.627 52.2912L177.263 52.6742Z",
    fill: "#24242B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.212 54.1066C177.212 54.1066 178.138 44.4778 182.697 46.4078C187.256 48.3378 182.201 57.1096 178.924 57.9877L177.212 54.1066Z",
    fill: "url(#paint0_linear_147_4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.288 148.096C204.598 138.845 195.017 125.245 191.054 120.085C189.917 118.611 189.291 116.805 189.271 114.943C189.154 101.841 193.595 94.9991 202.405 89.3459C202.405 89.3459 235.464 125.048 227.318 153.718C226.508 156.621 225.161 159.347 223.347 161.753C222.065 150.951 209.579 148.595 203.288 148.096Z",
    fill: "#FAA701"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.691 144.518L203.91 144.379C202.877 135.306 194.915 124.106 191.54 119.711L190.57 120.459C193.88 124.772 201.692 135.75 202.691 144.518Z",
    fill: "#895D06"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.037 149.377C203.146 148.956 203.23 148.528 203.288 148.096C209.58 148.595 222.065 150.951 223.349 161.753C209.072 180.638 169.719 173.824 169.719 173.824V166.476C169.719 166.476 199.943 160.861 203.037 149.377Z",
    fill: "#E8A988"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.503 171.795C173.503 171.795 167.692 158.085 157.454 162.948C147.215 167.812 148.02 170.994 148.02 170.994L173.503 171.795Z",
    fill: "#E8A988"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.81 174.64C174.771 175.139 174.54 175.604 174.167 175.938C173.793 176.271 173.305 176.448 172.805 176.43L119.75 174.576C119.347 174.563 118.959 174.424 118.639 174.18C118.319 173.936 118.083 173.598 117.963 173.214L116.423 168.286C116.334 168.004 116.311 167.704 116.356 167.411C116.401 167.119 116.512 166.84 116.681 166.597C116.85 166.353 117.073 166.152 117.331 166.008C117.59 165.864 117.879 165.781 118.175 165.766L137.522 164.739C137.698 164.729 137.874 164.743 138.045 164.782L173.293 172.587C173.751 172.688 174.157 172.952 174.436 173.329C174.715 173.707 174.847 174.172 174.81 174.64V174.64Z",
    fill: "#4C42AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.245 172.704L137.785 165.902L117.912 166.85L119.219 172.494L139.245 172.704Z",
    fill: "#4C42AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.433 99.3196C150.557 108.51 155.617 145.849 157.065 156.518C157.113 156.871 157.084 157.23 156.979 157.569C156.874 157.909 156.696 158.222 156.458 158.486C156.22 158.751 155.927 158.96 155.6 159.099C155.273 159.239 154.919 159.306 154.564 159.295L68.7354 156.839C68.1893 156.823 67.664 156.626 67.2428 156.278C66.8216 155.93 66.5285 155.452 66.4101 154.919L53.0581 94.7881C52.976 94.4177 52.981 94.0333 53.0725 93.6652C53.164 93.297 53.3396 92.9551 53.5855 92.6662C53.8315 92.3773 54.141 92.1494 54.4899 92.0004C54.8387 91.8513 55.2174 91.7851 55.5961 91.8071L147.145 97.1699C147.717 97.2035 148.26 97.4372 148.678 97.83C149.097 98.2229 149.364 98.7501 149.433 99.3196V99.3196Z",
    fill: "#6256CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.931 137.193L127.617 173.198L98.122 173.824L95.666 137.409C95.639 137.007 95.6983 136.603 95.84 136.225C95.9817 135.848 96.2026 135.505 96.4877 135.219C96.7729 134.934 97.1157 134.713 97.4933 134.571C97.8709 134.429 98.2745 134.369 98.6771 134.396L112.453 135.31C113.005 135.347 113.534 135.545 113.974 135.88C114.415 136.215 114.748 136.671 114.931 137.193V137.193Z",
    fill: "#584DC4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.576 173.707C139.651 173.938 139.671 174.182 139.633 174.422C139.596 174.661 139.502 174.888 139.36 175.084C139.218 175.28 139.032 175.44 138.816 175.55C138.6 175.66 138.362 175.718 138.12 175.718H91.9261C91.5198 175.718 91.1301 175.556 90.8428 175.269C90.5555 174.982 90.3941 174.592 90.3941 174.186V172.207C90.394 172 90.4358 171.796 90.5169 171.606C90.598 171.416 90.7167 171.244 90.866 171.101C91.0152 170.958 91.1918 170.846 91.3853 170.773C91.5787 170.7 91.7849 170.667 91.9914 170.676L138.187 172.658C138.497 172.672 138.796 172.779 139.044 172.967C139.292 173.154 139.478 173.412 139.576 173.707V173.707Z",
    fill: "#4F45B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.619 63.6814C172.962 66.3923 181.042 56.663 181.122 56.5642L180.49 56.0497C180.413 56.1441 172.657 65.4702 162.826 62.8933L162.619 63.6814Z",
    fill: "#443C8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.121 61.953L159.999 62.2845C159.783 62.8763 160.087 63.5316 160.679 63.7482L162.66 64.4733C163.252 64.6899 163.907 64.3857 164.124 63.7939L164.245 63.4624C164.462 62.8706 164.158 62.2153 163.566 61.9987L161.584 61.2736C160.993 61.0571 160.337 61.3612 160.121 61.953Z",
    fill: "url(#paint1_linear_147_4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.884 63.9401L163.344 65.2214L163.407 65.2444L163.884 63.9401Z",
    fill: "#443C8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.417 62.3224L163.171 65.6079L163.2 65.6176L164.059 64.0044L164.644 62.4053L164.417 62.3224Z",
    fill: "#443C8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.388 62.3118L163.142 65.5973L163.17 65.6078L164.417 62.3224L164.388 62.3118Z",
    fill: "#443C8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.359 62.3013L163.114 65.5868L163.142 65.5973L164.388 62.3119L164.359 62.3013Z",
    fill: "#443C8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.331 62.2906L163.085 65.5761L163.114 65.5867L164.359 62.3012L164.331 62.2906Z",
    fill: "#443C8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.303 62.2799L163.057 65.5654L163.085 65.576L164.331 62.2905L164.303 62.2799Z",
    fill: "#443C8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.274 62.2695L163.027 65.555L163.057 65.5656L164.303 62.2801L164.274 62.2695Z",
    fill: "#443C8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.245 62.2596L162.999 65.5451L163.028 65.5548L164.274 62.2693L164.245 62.2596Z",
    fill: "#443C8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.217 62.2491L162.971 65.5346L162.999 65.5452L164.245 62.2597L164.217 62.2491Z",
    fill: "#443C8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.188 62.2385L162.942 65.524L162.971 65.5346L164.217 62.2491L164.188 62.2385Z",
    fill: "#443C8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.16 62.2279L162.914 65.5134L162.942 65.524L164.188 62.2385L164.16 62.2279Z",
    fill: "#443C8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.131 62.2173L162.885 65.5028L162.914 65.5133L164.16 62.2279L164.131 62.2173Z",
    fill: "#443C8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.102 62.2068L162.856 65.4923L162.885 65.5028L164.132 62.2174L164.102 62.2068Z",
    fill: "#443C8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.074 62.1971L162.828 65.4817L162.856 65.4923L164.102 62.2068L164.074 62.1971Z",
    fill: "#443C8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.046 62.1865L162.8 65.472L162.828 65.4817L164.074 62.1971L164.046 62.1865Z",
    fill: "#443C8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.017 62.1758L162.771 65.4613L162.8 65.4718L164.046 62.1864L164.017 62.1758Z",
    fill: "#443C8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.988 62.1653L162.742 65.4508L162.771 65.4613L164.017 62.1759L163.988 62.1653Z",
    fill: "#443C8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.959 62.1548L162.714 65.4403L162.742 65.4508L163.989 62.1654L163.959 62.1548Z",
    fill: "#443C8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.931 62.144L162.685 65.4295L162.714 65.4401L163.959 62.1546L163.931 62.144Z",
    fill: "#443C8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.903 62.1335L162.657 65.419L162.685 65.4296L163.931 62.1441L163.903 62.1335Z",
    fill: "#443C8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.874 62.1239L162.628 65.4094L162.657 65.4191L163.903 62.1336L163.874 62.1239Z",
    fill: "#443C8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.846 62.1133L162.599 65.3988L162.628 65.4094L163.874 62.1239L163.846 62.1133Z",
    fill: "#443C8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.817 62.1027L162.571 65.3881L162.6 65.3987L163.846 62.1133L163.817 62.1027Z",
    fill: "#443C8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.788 62.092L162.542 65.3775L162.571 65.3881L163.817 62.1026L163.788 62.092Z",
    fill: "#443C8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.76 62.0814L162.514 65.3669L162.542 65.3775L163.788 62.092L163.76 62.0814Z",
    fill: "#443C8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.732 62.0708L162.486 65.3563L162.514 65.3669L163.76 62.0814L163.732 62.0708Z",
    fill: "#443C8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.703 62.0612L162.457 65.3457L162.486 65.3563L163.732 62.0709L163.703 62.0612Z",
    fill: "#443C8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.674 62.0505L162.428 65.336L162.457 65.3457L163.703 62.0611L163.674 62.0505Z",
    fill: "#443C8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.645 62.0399L162.4 65.3254L162.428 65.336L163.674 62.0505L163.645 62.0399Z",
    fill: "#443C8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.617 62.0293L162.371 65.3148L162.4 65.3254L163.645 62.0399L163.617 62.0293Z",
    fill: "#443C8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.589 62.0188L162.343 65.3043L162.371 65.3149L163.617 62.0294L163.589 62.0188Z",
    fill: "#443C8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.56 62.0081L162.314 65.2935L162.343 65.3041L163.589 62.0186L163.56 62.0081Z",
    fill: "#443C8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.531 61.9984L162.285 65.283L162.315 65.2936L163.56 62.0081L163.531 61.9984Z",
    fill: "#443C8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.503 61.9879L162.257 65.2734L162.285 65.2831L163.531 61.9985L163.503 61.9879Z",
    fill: "#443C8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.474 61.9774L162.228 65.2629L162.257 65.2735L163.503 61.988L163.474 61.9774Z",
    fill: "#443C8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.446 61.9667L162.2 65.2521L162.228 65.2627L163.474 61.9773L163.446 61.9667Z",
    fill: "#443C8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.418 61.9561L162.172 65.2415L162.2 65.2521L163.446 61.9666L163.418 61.9561Z",
    fill: "#443C8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.388 61.9456L162.142 65.231L162.171 65.2416L163.418 61.9561L163.388 61.9456Z",
    fill: "#443C8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.36 61.9348L162.114 65.2203L162.142 65.2309L163.388 61.9454L163.36 61.9348Z",
    fill: "#443C8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.332 61.9253L162.086 65.2099L162.114 65.2205L163.36 61.935L163.332 61.9253Z",
    fill: "#443C8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.303 61.9147L162.057 65.2002L162.086 65.2099L163.332 61.9253L163.303 61.9147Z",
    fill: "#443C8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.275 61.9041L162.029 65.1895L162.057 65.2001L163.303 61.9146L163.275 61.9041Z",
    fill: "#443C8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.245 61.8936L162 65.179L162.028 65.1896L163.275 61.9041L163.245 61.8936Z",
    fill: "#443C8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.217 61.8829L161.971 65.1684L162 65.179L163.245 61.8935L163.217 61.8829Z",
    fill: "#443C8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.189 61.8722L161.943 65.1577L161.971 65.1683L163.217 61.8828L163.189 61.8722Z",
    fill: "#443C8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.16 61.8625L161.915 65.1471L161.943 65.1577L163.189 61.8723L163.16 61.8625Z",
    fill: "#443C8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.132 61.8521L161.886 65.1375L161.915 65.1472L163.16 61.8626L163.132 61.8521Z",
    fill: "#443C8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.103 61.8414L161.857 65.1269L161.886 65.1375L163.132 61.852L163.103 61.8414Z",
    fill: "#443C8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.074 61.8309L161.828 65.1164L161.857 65.127L163.103 61.8415L163.074 61.8309Z",
    fill: "#443C8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.046 61.8203L161.8 65.1058L161.828 65.1164L163.074 61.8309L163.046 61.8203Z",
    fill: "#443C8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.018 61.8096L161.772 65.095L161.8 65.1056L163.046 61.8202L163.018 61.8096Z",
    fill: "#443C8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.989 61.7991L161.743 65.0845L161.772 65.0951L163.018 61.8097L162.989 61.7991Z",
    fill: "#443C8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.96 61.7893L161.714 65.0748L161.743 65.0845L162.989 61.799L162.96 61.7893Z",
    fill: "#443C8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.932 61.7789L161.686 65.0644L161.714 65.075L162.96 61.7895L162.932 61.7789Z",
    fill: "#443C8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.903 61.7681L161.657 65.0535L161.686 65.0641L162.932 61.7787L162.903 61.7681Z",
    fill: "#443C8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.875 61.7576L161.629 65.043L161.657 65.0536L162.903 61.7682L162.875 61.7576Z",
    fill: "#443C8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.847 61.7471L161.601 65.0325L161.629 65.0431L162.875 61.7577L162.847 61.7471Z",
    fill: "#443C8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.817 61.7363L161.571 65.0218L161.601 65.0324L162.847 61.7469L162.817 61.7363Z",
    fill: "#443C8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.789 61.7268L161.543 65.0123L161.571 65.022L162.818 61.7365L162.789 61.7268Z",
    fill: "#443C8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.76 61.7161L161.515 65.0015L161.543 65.0121L162.789 61.7267L162.76 61.7161Z",
    fill: "#443C8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.732 61.7056L161.486 64.991L161.515 65.0016L162.76 61.7162L162.732 61.7056Z",
    fill: "#443C8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.704 61.6948L161.458 64.9803L161.486 64.9909L162.732 61.7054L162.704 61.6948Z",
    fill: "#443C8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.674 61.6843L161.429 64.9698L161.458 64.9804L162.704 61.6949L162.674 61.6843Z",
    fill: "#443C8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.646 61.6737L161.4 64.9592L161.429 64.9698L162.675 61.6843L162.646 61.6737Z",
    fill: "#443C8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.618 61.6642L161.372 64.9488L161.4 64.9594L162.646 61.6739L162.618 61.6642Z",
    fill: "#443C8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.589 61.6533L161.343 64.9379L161.372 64.9485L162.618 61.6639L162.589 61.6533Z",
    fill: "#443C8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.561 61.6428L161.315 64.9283L161.343 64.938L162.589 61.6534L162.561 61.6428Z",
    fill: "#443C8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.532 61.6324L161.286 64.9179L161.315 64.9285L162.561 61.643L162.532 61.6324Z",
    fill: "#443C8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.503 61.6217L161.257 64.9072L161.286 64.9178L162.533 61.6323L162.503 61.6217Z",
    fill: "#443C8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.475 61.6112L161.229 64.8967L161.257 64.9073L162.503 61.6218L162.475 61.6112Z",
    fill: "#443C8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.446 61.6005L161.201 64.8859L161.229 64.8965L162.475 61.6111L162.446 61.6005Z",
    fill: "#443C8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.418 61.5909L161.172 64.8764L161.201 64.8861L162.446 61.6006L162.418 61.5909Z",
    fill: "#443C8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.389 61.5802L161.143 64.8657L161.172 64.8763L162.418 61.5908L162.389 61.5802Z",
    fill: "#443C8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.36 61.5698L161.115 64.8553L161.143 64.8659L162.39 61.5804L162.36 61.5698Z",
    fill: "#443C8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.332 61.559L161.086 64.8444L161.115 64.855L162.36 61.5695L162.332 61.559Z",
    fill: "#443C8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.304 61.5483L161.058 64.8338L161.086 64.8444L162.332 61.5589L162.304 61.5483Z",
    fill: "#443C8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.275 61.5378L161.03 64.8233L161.058 64.8339L162.304 61.5484L162.275 61.5378Z",
    fill: "#443C8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.247 61.5282L161 64.8128L161.03 64.8234L162.275 61.5379L162.247 61.5282Z",
    fill: "#443C8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.218 61.5177L160.972 64.8032L161.001 64.8129L162.247 61.5283L162.218 61.5177Z",
    fill: "#443C8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.189 61.507L160.943 64.7924L160.972 64.803L162.218 61.5175L162.189 61.507Z",
    fill: "#443C8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.161 61.4965L160.915 64.7819L160.943 64.7925L162.189 61.507L162.161 61.4965Z",
    fill: "#443C8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.133 61.4857L160.887 64.7712L160.915 64.7818L162.161 61.4963L162.133 61.4857Z",
    fill: "#443C8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.104 61.4752L160.858 64.7607L160.887 64.7713L162.133 61.4858L162.104 61.4752Z",
    fill: "#443C8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.075 61.4655L160.829 64.75L160.857 64.7606L162.104 61.4752L162.075 61.4655Z",
    fill: "#443C8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.047 61.455L160.801 64.7395L160.829 64.7501L162.075 61.4655L162.047 61.455Z",
    fill: "#443C8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.018 61.4443L160.772 64.7298L160.801 64.7395L162.047 61.4549L162.018 61.4443Z",
    fill: "#443C8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.99 61.4337L160.744 64.7192L160.772 64.7298L162.018 61.4443L161.99 61.4337Z",
    fill: "#443C8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.961 61.4233L160.715 64.7088L160.744 64.7194L161.99 61.4339L161.961 61.4233Z",
    fill: "#443C8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.932 61.4125L160.686 64.6979L160.715 64.7085L161.961 61.4231L161.932 61.4125Z",
    fill: "#443C8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.904 61.402L160.658 64.6874L160.686 64.698L161.932 61.4126L161.904 61.402Z",
    fill: "#443C8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.875 61.3921L160.63 64.6776L160.658 64.6873L161.904 61.4018L161.875 61.3921Z",
    fill: "#443C8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.847 61.3817L160.601 64.6672L160.63 64.6778L161.875 61.3923L161.847 61.3817Z",
    fill: "#443C8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.819 61.3711L160.573 64.6566L160.601 64.6672L161.847 61.3817L161.819 61.3711Z",
    fill: "#443C8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.789 61.3605L160.544 64.6459L160.572 64.6565L161.818 61.3711L161.789 61.3605Z",
    fill: "#443C8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.761 61.3499L160.515 64.6353L160.544 64.6459L161.789 61.3604L161.761 61.3499Z",
    fill: "#443C8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.733 61.3394L160.487 64.6248L160.515 64.6354L161.761 61.3499L161.733 61.3394Z",
    fill: "#443C8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.704 61.3297L160.458 64.6143L160.487 64.6249L161.733 61.3394L161.704 61.3297Z",
    fill: "#443C8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.676 61.3191L160.43 64.6037L160.458 64.6143L161.704 61.3297L161.676 61.3191Z",
    fill: "#443C8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.647 61.3085L160.401 64.594L160.429 64.6037L161.676 61.3191L161.647 61.3085Z",
    fill: "#443C8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.618 61.2979L160.372 64.5833L160.401 64.5939L161.647 61.3084L161.618 61.2979Z",
    fill: "#443C8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.59 61.2874L160.344 64.5728L160.372 64.5834L161.618 61.2979L161.59 61.2874Z",
    fill: "#443C8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.562 61.2766L160.316 64.5621L160.344 64.5727L161.59 61.2872L161.562 61.2766Z",
    fill: "#443C8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.533 61.267L160.287 64.5516L160.316 64.5621L161.562 61.2767L161.533 61.267Z",
    fill: "#443C8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.504 61.2566L160.258 64.5412L160.287 64.5518L161.533 61.2672L161.504 61.2566Z",
    fill: "#443C8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.475 61.2457L160.23 64.5312L160.258 64.5409L161.504 61.2563L161.475 61.2457Z",
    fill: "#443C8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.447 61.2352L160.201 64.5207L160.23 64.5313L161.475 61.2458L161.447 61.2352Z",
    fill: "#443C8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.419 61.2246L160.173 64.5101L160.201 64.5207L161.447 61.2352L161.419 61.2246Z",
    fill: "#443C8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.39 61.214L160.144 64.4995L160.173 64.5101L161.419 61.2246L161.39 61.214Z",
    fill: "#443C8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.361 61.2034L160.115 64.4888L160.144 64.4994L161.39 61.214L161.361 61.2034Z",
    fill: "#443C8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.333 61.1937L160.087 64.4783L160.115 64.4889L161.361 61.2034L161.333 61.1937Z",
    fill: "#443C8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.304 61.1832L160.058 64.4687L160.087 64.4784L161.333 61.1938L161.304 61.1832Z",
    fill: "#443C8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.276 61.1725L160.03 64.458L160.058 64.4685L161.304 61.1831L161.276 61.1725Z",
    fill: "#443C8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.248 61.1619L160.001 64.4473L160.03 64.4579L161.276 61.1725L161.248 61.1619Z",
    fill: "#443C8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.218 61.1514L159.972 64.4368L160.002 64.4474L161.248 61.162L161.218 61.1514Z",
    fill: "#443C8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.19 61.1406L159.944 64.4261L159.972 64.4367L161.218 61.1512L161.19 61.1406Z",
    fill: "#443C8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.162 61.1311L159.916 64.4157L159.944 64.4263L161.19 61.1408L161.162 61.1311Z",
    fill: "#443C8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.133 61.1205L159.887 64.4051L159.916 64.4157L161.162 61.1311L161.133 61.1205Z",
    fill: "#443C8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.105 61.11L159.859 64.3955L159.887 64.4052L161.133 61.1206L161.105 61.11Z",
    fill: "#443C8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.076 61.0992L159.83 64.3847L159.859 64.3953L161.105 61.1098L161.076 61.0992Z",
    fill: "#443C8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.047 61.0886L159.801 64.3741L159.83 64.3847L161.076 61.0992L161.047 61.0886Z",
    fill: "#443C8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.019 61.0782L159.773 64.3637L159.801 64.3743L161.047 61.0888L161.019 61.0782Z",
    fill: "#443C8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.99 61.0675L159.745 64.353L159.773 64.3636L161.019 61.0781L160.99 61.0675Z",
    fill: "#443C8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.962 61.0577L159.716 64.3423L159.745 64.3529L160.99 61.0674L160.962 61.0577Z",
    fill: "#443C8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.933 61.0472L159.687 64.3327L159.716 64.3424L160.962 61.0578L160.933 61.0472Z",
    fill: "#443C8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.904 61.0366L159.658 64.3221L159.687 64.3327L160.933 61.0472L160.904 61.0366Z",
    fill: "#443C8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.876 61.0261L159.63 64.3116L159.658 64.3222L160.904 61.0367L160.876 61.0261Z",
    fill: "#443C8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.848 61.0155L159.602 64.301L159.63 64.3116L160.876 61.0261L160.848 61.0155Z",
    fill: "#443C8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.819 61.0048L159.573 64.2902L159.602 64.3008L160.848 61.0154L160.819 61.0048Z",
    fill: "#443C8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.79 60.9952L159.544 64.2798L159.573 64.2904L160.819 61.0049L160.79 60.9952Z",
    fill: "#443C8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.762 60.9845L159.516 64.27L159.544 64.2797L160.79 60.9951L160.762 60.9845Z",
    fill: "#443C8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.733 60.974L159.487 64.2595L159.516 64.2701L160.762 60.9846L160.733 60.974Z",
    fill: "#443C8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.705 60.9634L159.459 64.2489L159.487 64.2594L160.733 60.974L160.705 60.9634Z",
    fill: "#443C8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.677 60.9526L159.431 64.2381L159.459 64.2487L160.705 60.9632L160.677 60.9526Z",
    fill: "#443C8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.648 60.9421L159.401 64.2276L159.431 64.2382L160.677 60.9527L160.648 60.9421Z",
    fill: "#443C8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.619 60.9326L159.373 64.2172L159.401 64.2278L160.647 60.9423L160.619 60.9326Z",
    fill: "#443C8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.59 60.9219L159.345 64.2065L159.373 64.2171L160.619 60.9325L160.59 60.9219Z",
    fill: "#443C8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.562 60.9114L159.316 64.1969L159.345 64.2066L160.59 60.922L160.562 60.9114Z",
    fill: "#443C8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.534 60.9008L159.288 64.1862L159.316 64.1968L160.562 60.9113L160.534 60.9008Z",
    fill: "#443C8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.504 60.8901L159.258 64.1756L159.288 64.1862L160.534 60.9007L160.504 60.8901Z",
    fill: "#443C8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.476 60.8795L159.23 64.165L159.258 64.1756L160.505 60.8901L160.476 60.8795Z",
    fill: "#443C8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.448 60.8689L159.202 64.1544L159.23 64.165L160.476 60.8795L160.448 60.8689Z",
    fill: "#443C8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.419 60.8595L159.173 64.1441L159.202 64.1547L160.448 60.8692L160.419 60.8595Z",
    fill: "#443C8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.391 60.8486L159.145 64.1341L159.173 64.1438L160.419 60.8592L160.391 60.8486Z",
    fill: "#443C8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.362 60.838L159.116 64.1235L159.145 64.1341L160.391 60.8486L160.362 60.838Z",
    fill: "#443C8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.333 60.8274L159.087 64.1129L159.116 64.1235L160.362 60.838L160.333 60.8274Z",
    fill: "#443C8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.305 60.8169L159.059 64.1024L159.087 64.113L160.333 60.8275L160.305 60.8169Z",
    fill: "#443C8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.277 60.8063L159.031 64.0917L159.059 64.1023L160.305 60.8169L160.277 60.8063Z",
    fill: "#443C8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.248 60.7966L159.002 64.0812L159.031 64.0918L160.277 60.8063L160.248 60.7966Z",
    fill: "#443C8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.219 60.786L158.973 64.0706L159.002 64.0812L160.248 60.7966L160.219 60.786Z",
    fill: "#443C8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.191 60.7755L158.945 64.061L158.974 64.0707L160.22 60.7861L160.191 60.7755Z",
    fill: "#443C8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.162 60.7648L158.916 64.0502L158.944 64.0608L160.19 60.7754L160.162 60.7648Z",
    fill: "#443C8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.134 60.7545L158.888 64.04L158.916 64.0506L160.162 60.7651L160.134 60.7545Z",
    fill: "#443C8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.105 60.7438L159.988 62.349L159.312 64.1952L158.888 64.0398L160.134 60.7544L160.105 60.7438Z",
    fill: "#443C8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.654 62.2262L159.983 61.0763L160.063 61.1054L159.654 62.2262Z",
    fill: "#443C8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.731 44.529C182.731 44.529 182.007 27.0833 171.877 23.4519C171.877 23.4519 175.054 22.6577 177.868 24.7544C180.682 26.8512 187.076 36.5311 185.257 45.4548C183.033 45.7416 182.731 44.529 182.731 44.529Z",
    fill: "#443C8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.693 43.8417C190.245 46.0664 188.202 53.2277 188.202 53.2277C187.65 58.595 185.625 60.9353 183.418 61.8231C182.676 62.1205 181.87 62.2209 181.078 62.1146C180.286 62.0082 179.535 61.6987 178.898 61.2162C178.261 60.7336 177.76 60.0945 177.443 59.3608C177.126 58.6272 177.004 57.824 177.09 57.0295C177.247 55.5698 177.376 54.1782 177.355 53.676C177.314 52.4476 179.142 41.617 184.693 43.8417Z",
    fill: "#352F6D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.827 45.5878C184.426 45.5922 185.006 45.7985 185.473 46.1733C185.941 46.5482 186.268 47.0697 186.403 47.6537C188.388 56.2667 183.208 60.6852 181.108 60.4134C178.897 60.1275 180.869 49.6039 181.827 46.9891C182.233 45.8931 183.032 45.5807 183.827 45.5878Z",
    fill: "#443C8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.692 137.476L151.375 137.388L147.159 104.13C147.03 103.121 146.553 102.188 145.811 101.493C145.068 100.797 144.106 100.383 143.091 100.321L63.9779 95.5426L63.9365 96.2301L143.049 101.008C143.904 101.06 144.715 101.409 145.34 101.995C145.966 102.58 146.367 103.366 146.476 104.216L150.692 137.476Z",
    fill: "#D1CDF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.579 146.863L151.896 146.949L152.803 154.15L153.486 154.064L152.579 146.863Z",
    fill: "#D1CDF4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_147_4",
    x1: 179.542,
    y1: 51.7029,
    x2: 156.945,
    y2: 45.83,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEBBBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF928E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_147_4",
    x1: 159.919,
    y1: 62.8854,
    x2: 164.305,
    y2: 62.8854,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F52FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042E2"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard3);
export default __webpack_public_path__ + "static/media/card3.ae3b7ede2dd68c2f08cd179bd2476051.svg";
export { ForwardRef as ReactComponent };